// SPDX-License-Identifier: LicenseRef-Proprietary

import { useMemo } from 'react';
import { useVaccineDashboardStore } from '../../../store/vaccineDashboardStore';
import { type VaccineInputs, type VaccineOutputs } from '../lib/models';

/**
 * Hook to get vaccine model outputs - uses backend results when available,
 * returns null otherwise (loading state)
 */
export function useVaccineModelWithBackend(inputs: VaccineInputs): VaccineOutputs | null {
  const backendResults = useVaccineDashboardStore((state) => state.backendResults);
  const backendComputedAt = useVaccineDashboardStore((state) => state.backendComputedAt);

  return useMemo(() => {
    const isFresh = backendComputedAt && (Date.now() - backendComputedAt) < 5 * 60 * 1000;
    
    if (backendResults && isFresh) {
      return backendResults;
    }
    
    // Return null to indicate loading state
    return null;
  }, [backendResults, backendComputedAt]);
}
